import React from 'react'
import { useIntl } from 'react-intl'

import { Modal } from '@lyrahealth-inc/ui-core-crossplatform/src/organisms/modal/Modal'

import { TaskModalContents, TaskModalContentsProps } from './TaskModalContents'

export type TaskModalProps = TaskModalContentsProps & {
  visible: boolean
}

export const TaskModal: React.FC<TaskModalProps> = (props) => {
  const { formatMessage } = useIntl()
  return (
    <Modal
      visible={props.visible}
      onRequestClose={props.onClose}
      width='450px'
      showCloseIcon={false}
      modalContents={<TaskModalContents key={props.visible ? 'open' : 'closed'} {...props} />}
      accessibilityLabel={formatMessage({
        defaultMessage: 'Task modal',
        description: 'Accessibility label for task modal dialog',
      })}
    />
  )
}
